import Vue from 'vue';

export default {
    addOns: {
        update({ cartId, selected }) {
            const path = 'purchase/add-ons/update';
            const payload = { cartId, selected };
            return Vue.axios.post(path, payload);
        },
    },
    cart: {
        create({ employeeId, customerId, arkona, stockNumber, vin }) {
            const path = 'purchase/create';
            const payload = { customerId, arkona, stockNumber, vin };
            if (employeeId) {
                payload.employeeId = employeeId;
            }
            return Vue.axios.post(path, payload);
        },
        getFees({ cartId }) {
            const path = `purchase/fees/${cartId}`;
            return Vue.axios.get(path);
        },
    },
    deliveryOptions: {
        update({ cartId, data }) {
            const path = 'purchase/delivery/update';
            const payload = { cartId, data };
            return Vue.axios.post(path, payload);
        },
    },
    documents: {
        update(formData) {
            const path = 'purchase/documents/update';
            const options = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };
            return Vue.axios.post(path, formData, options);
        },
    },
    financing: {
        getOptions(payload) {
            const path = 'purchase/financing/options';
            return Vue.axios.post(path, payload);
        },
        getRates({ arkona, vehicleType }) {
            const path = `purchase/financing/rates/${arkona}/${vehicleType}`;
            return Vue.axios.get(path);
        },
        getTaxIdByPostalCode(postalCode) {
            const path = `payment-calculator/tax-locations/${postalCode}`;
            return Vue.axios.get(path);
        },
        update({ cartId, data }) {
            const path = 'purchase/financing/update';
            const payload = { cartId, data };
            return Vue.axios.post(path, payload);
        },

        /**
         * Not currently used
         */
        // getLenderNames() {
        //     const path = 'purchase/financing/lenders';
        //     return Vue.axios.get(path);
        // },
    },
    personalDetails: {
        update({ cartId, data }) {
            const path = 'purchase/personal-details/update';
            const payload = { cartId, data };
            return Vue.axios.post(path, payload);
        },
    },
    steps: {
        completeStep({ cartId, stepName, customerId, employeeId }) {
            const path = 'purchase/steps/complete';
            const payload = { cartId, stepName, customerId, employeeId };
            return Vue.axios.post(path, payload);
        },
        getAll({ customerId, cartId, employeeId = '' }) {
            // We only want to pass employeeId on the first fetch of steps (when we are logging for employee)
            const path = `purchase/steps/${customerId}/${cartId}/${employeeId}`;
            return Vue.axios.get(path);
        },
    },
    // These are the old trade-in endpoints, everything except update was replaced by perseus
    tradeIn: {
        update({ cartId, data }) {
            const path = 'purchase/trade-in/update';
            const payload = { cartId, data };
            return Vue.axios.post(path, payload);
        },
    },
    // These are the new trade-in endpoints
    perseus: {
        getVehiclesByVin({ vin }) {
            const path = `perseus/vehicle/by-vin/${vin}`;
            return Vue.axios.get(path);
        },
        getVehiclesByLicense({ state, license }) {
            const path = `perseus/common/plate-to-vin/${state}/${license}`;
            return Vue.axios.get(path);
        },
        getYears() {
            const path = `perseus/vehicle/years`;
            return Vue.axios.get(path);
        },
        getMakes({ year }) {
            const path = `perseus/vehicle/makes`;
            return Vue.axios.get(path, { params: { year } });
        },
        getModels({ year, make }) {
            const path = `perseus/vehicle/models`;
            return Vue.axios.get(path, { params: { year, make } });
        },
        getVehiclesByYmm({ year, make, model }) {
            const path = `perseus/vehicle/trims`;
            return Vue.axios.get(path, { params: { year, make, model } });
        },
        getDetailsByGuid({ guid }) {
            const path = `perseus/vehicle/by-guid/${guid}`;
            return Vue.axios.get(path);
        },
        postOffer({ payload }) {
            const path = `perseus/offer`;
            return Vue.axios.post(path, payload);
        },
        offerAccept({ form, range, customer, employeeId }) {
            const path = `perseus/offer/accept`;
            const payload = { form, range, customer, employeeId };
            return Vue.axios.post(path, payload);
        },
    },

    kbb: {
        getYears: () => {
            const endpoint = 'kbb/years';
            return Vue.axios.post(endpoint, {
                isProduction: process.env.NODE_ENV === 'production',
            });
        },
        getMakes: ({ yearId }) => {
            const endpoint = 'kbb/makes';
            return Vue.axios.post(endpoint, {
                isProduction: process.env.NODE_ENV === 'production',
                yearId,
            });
        },
        getModels: ({ yearId, makeId }) => {
            const endpoint = 'kbb/models';
            return Vue.axios.post(endpoint, {
                isProduction: process.env.NODE_ENV === 'production',
                yearId,
                makeId,
            });
        },
        getTrims: ({ yearId, makeId, modelId }) => {
            const endpoint = 'kbb/trims';
            return Vue.axios.post(endpoint, {
                isProduction: process.env.NODE_ENV === 'production',
                yearId,
                makeId,
                modelId,
            });
        },
        getVehicles: ({ yearId, makeId, modelId, trimId }) => {
            const endpoint = 'kbb/vehicles';
            return Vue.axios.post(endpoint, {
                isProduction: process.env.NODE_ENV === 'production',
                yearId,
                makeId,
                modelId,
                trimId,
            });
        },
        getVehiclesByVin: ({ vin }) => {
            const endpoint = 'kbb/vehicles-by-vin';
            return Vue.axios.post(endpoint, {
                isProduction: process.env.NODE_ENV === 'production',
                vin,
            });
        },
        getVehicleOptions: ({ vehicleId }) => {
            const endpoint = 'kbb/vehicle-options';
            return Vue.axios.post(endpoint, {
                isProduction: process.env.NODE_ENV === 'production',
                vehicleId,
            });
        },
        validateAndValueVehicle: ({ form }) => {
            const endpoint = 'kbb/validate-and-value';
            return Vue.axios.post(endpoint, {
                isProduction: process.env.NODE_ENV === 'production',
                ...form,
            });
        },
    },

    /**
     * Not currently used
     */
    // credit: {
    //     update({ cartId, data }) {
    //         const path = 'purchase/credit/update';
    //         const payload = { cartId, data };
    //         return Vue.axios.post(path, payload);
    //     },
    // },
};
